import { FormControl } from 'baseui/form-control'
import { SIZE } from 'baseui/input'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'
import getError from '@/containers/SubscriptionFormPage/getError'
import useAddress from '@/containers/SubscriptionFormPageNew/Components/Address/useAddress'

const PresenceInDays = () => {
  const { t, residenceType, energyLandscape, updateAddressEnergyLandscape, errors } = useAddress()
  if (residenceType !== 'secondary') return null
  return (
    <FormControl>
      <SDInput
        label={t('subscriptionTools:estimator.presence_in_days.label')}
        size={SIZE.compact}
        currentValue={energyLandscape?.numberDays}
        pattern={'[0-9]+'}
        min={'1'}
        max={'7'}
        onBlur={numberDays => updateAddressEnergyLandscape({ numberDays })}
        error={getError('number_of_days', errors)}
      />
    </FormControl>
  )
}

export default PresenceInDays
